const c = (n) => n.filter((o, e) => n.indexOf(o) === e);
function f(n) {
  return !!n;
}
function u(n) {
  return n.reduce(
    (o, e) => e.predicate ? (i) => o(i) && e.filter(i) : o,
    (o) => !0
  );
}
function a(n, o, e = "asc") {
  return n.concat().sort((i, s) => {
    let t = o(i), r = o(s);
    return typeof t == "string" && typeof r == "string" ? (t = t.toLowerCase(), r = r.toLowerCase(), e === "asc" ? t.localeCompare(r) : r.localeCompare(t)) : t instanceof Date && r instanceof Date ? (t = t.getTime(), r = r.getTime(), e === "asc" ? t - r : r - t) : typeof t == "number" && typeof r == "number" ? e === "asc" ? t - r : r - t : 0;
  });
}
function p(n, o) {
  const e = {};
  return n.forEach((i) => {
    const s = o(i);
    s && (e[s] || (e[s] = []), e[s].push(i));
  }), e;
}
const l = {
  distinct: c,
  removeFalsey: f,
  composeFilters: u,
  orderBy: a,
  groupBy: p
};
export {
  l as ArrayUtils,
  u as composeFilters,
  c as distinct,
  p as groupBy,
  a as orderBy,
  f as removeFalsey
};
